export enum HabitatTypeProps {
    FledgedDate = 'FledgedDate',
    NumberOfFledged = 'NumberOfFledged',
    YoungAge = 'YoungAge',
    NumberOfYoung = 'NumberOfYoung',
}